/** Client-side search for the feature flag Flags and Product updates lists over their snapshots. */

const holds = (needle: string, values: string[]) =>
  values.some((value) => value.toLowerCase().includes(needle));

/** True when `q` (any case) is in the flag's key, description or products. */
export function matchesFlagSearch(
  flag: { key: string; description: string; products: string[] },
  q: string,
): boolean {
  const needle = q.trim().toLowerCase();
  return !needle || holds(needle, [flag.key, flag.description, ...flag.products]);
}

/** True when `q` (any case) is in the update's title, key, description or products. */
export function matchesUpdateSearch(
  update: { title: string; key: string; description: string; products: string[] },
  q: string,
): boolean {
  const needle = q.trim().toLowerCase();
  return (
    !needle || holds(needle, [update.title, update.key, update.description, ...update.products])
  );
}
